export default __webpack_public_path__ + "static/media/2cd43b_0edde190f9eb4ffbb669f6de80034d54_mv2_d_1280_1230_s_2.808cd972.png";